module.exports = __webpack_public_path__ + "static/img/guards3.11ca39c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guards3.jpg
// module id = iUe8
// module chunks = 0